/**
 * Global utility class defined in `global.css`. Referenced through a constant
 * so the string exists in exactly one place - it is not a CSS Module export and
 * therefore gets no compile-time check of its own.
 *
 * Pair it with a component class that sets `--fade-delay` to stagger.
 */
export const FADE_UP = 'fade-up';
